/**
 * Theme Provider - Wraps application with Radix UI Theme
 * 
 * AI Agent Note: This component provides theme configuration to the entire app.
 * To modify theme globally, update config/theme.ts
 */

import React, { ReactNode } from 'react';
import { Theme } from '@radix-ui/themes';
import { radixThemeConfig } from '../config/theme';
import '@radix-ui/themes/styles.css';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <Theme
      appearance={radixThemeConfig.appearance}
      accentColor={radixThemeConfig.accentColor}
      grayColor={radixThemeConfig.grayColor}
      radius={radixThemeConfig.radius}
      scaling={radixThemeConfig.scaling}
      panelBackground={radixThemeConfig.panelBackground}
      style={{
        fontFamily: "'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
      }}
    >
      {children}
    </Theme>
  );
};
